<template>
  <div class="custom-m-b-8 bold custom-f-s-18">
    <span v-if="isCompleted">
      {{ $t("numberQuestionOfQuizCompleted", {
        msg: numberOfQuizzesHavePassed,
        num: numberOfQuizzes,
      }) }}
    </span>

    <span v-else>
      {{ $t("numberQuestionOfQuiz", {
        msg: numberOfQuizzesHavePassed,
        num: numberOfQuizzes,
      }) }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    numberOfQuizzesHavePassed: {
      type: Number,
      required: true,
    },
    numberOfQuizzes: {
      type: Number,
      required: true,
    },
    isCompleted: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
